import 'regenerator-runtime/runtime';
import { call, select, take, takeEvery } from 'redux-saga/effects';

import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  ModalType,
  NavigationRoute,
  RequestVorvertragStatusValidationPayload,
} from '@ps20-frontend/shop-integration-redux';
import {
  App,
  VorvertragStatusValidationResult,
} from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { IAppState } from '../../appState';
import {
  hasManuallyEnteredVorvertragCanceledOverOneYear,
  getCanceledManualVorvertragNumbers,
} from './vorvertragStatusValidator';


export function* provideVorvertragStatusValidationSaga() {
  yield takeEvery(
    GlobalActions.REQUEST_VORVERTRAG_STATUS_VALIDATION,
    provideVorvertragStatusValidation,
  );
}

export function* provideVorvertragStatusValidation(
  action: GlobalAction<RequestVorvertragStatusValidationPayload>,
) {
  const actionPayload = action.payload;
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();

  const validationResult = validateVorvertragStatus(state, actionPayload);

  if (validationResult === VorvertragStatusValidationResult.VORVERTRAG_MANUELL_SEIT_MEHR_ALS_EINEM_JAHR_STORNIERT) {
    const body = `
      <br/>
      Manuell angegebener Vorvertrag seit mehr als einem Jahr storniert. Bitte als Neuantrag einreichen.
      <br/>
    `;
    yield call(
      globalPut.put,
      new GlobalActions().requestModal(ModalType.TAAS_FEHLER_OHNE_RETRY, { body }),
    );

    yield take(GlobalActions.CLOSE_MODAL);

    const navigationRoute: NavigationRoute = { appId: App.SHOP_DASHBOARD };
    yield call(
      globalPut.put,
      new GlobalActions().navigationRequested(navigationRoute),
    );
  }

  yield call(
    globalPut.put,
    new GlobalActions().provideVorvertragStatusValidation({
      appId: actionPayload.appId,
      angebotsId: actionPayload.angebotsId,
      validationResult,
    }),
  );
}


export const validateVorvertragStatus = (
  state: IAppState,
  actionPayload: RequestVorvertragStatusValidationPayload,
): VorvertragStatusValidationResult | null => {
  const standardVorvertraege = [
    ...state.vorvertraege,
    ...state.fremdVertraege.filter(fremdVertrag => 'produktIds' in fremdVertrag),
    ...(state.weitereVertraege || []),
  ];

  if (!actionPayload.selectedVorvertragsNummern || actionPayload.selectedVorvertragsNummern.length === 0) {
    return null;
  }

  const selectedVorvertragsNummern = actionPayload.selectedVorvertragsNummern;

  const selectedVorvertraege = standardVorvertraege.filter(vertrag =>
    selectedVorvertragsNummern.some(selectedNummer => {
      const vertragsnummerMatch = selectedNummer.vertragsnummer === vertrag.vertragsnummer;

      if (selectedNummer.spLaufnummer === undefined || selectedNummer.spLaufnummer === null) {
        return vertragsnummerMatch;
      }

      return vertragsnummerMatch && selectedNummer.spLaufnummer === vertrag.spLaufnummer;
    })
  );

  if (hasManuallyEnteredVorvertragCanceledOverOneYear(selectedVorvertraege)) {
    const canceledNumbers = getCanceledManualVorvertragNumbers(selectedVorvertraege);
    PS20Logger.error(
      App.SHOP_DASHBOARD,
      'Validation failed: Manually entered pre-contract(s) canceled over 1 year.',
      JSON.stringify({
        appId: actionPayload.appId,
        angebotsId: actionPayload.angebotsId,
        canceledContracts: canceledNumbers,
      }),
    );
    return VorvertragStatusValidationResult.VORVERTRAG_MANUELL_SEIT_MEHR_ALS_EINEM_JAHR_STORNIERT;
  }
  return null;
};
